import { FilterField, FilterPanel } from '../common';

function EntityFilters({
  values,
  onChange,
  onSubmit,
  onReset,
  statusOptions,
  searchFieldName = 'supplierName',
  searchLabel = 'Supplier Name',
  searchPlaceholder = 'Search company or owner name',
  showDateFilter = true,
  showApply = true,
  searchSuggestions = [],
}) {
  return (
    <FilterPanel
      onSubmit={onSubmit}
      onReset={onReset}
      showApply={showApply}
      layoutClassName={
        showDateFilter
          ? undefined
          : 'grid gap-2.5 md:grid-cols-[minmax(260px,520px)_minmax(0,1fr)_190px_auto]'
      }
    >
      <FilterField
        label={searchLabel}
        name={searchFieldName}
        type="search"
        value={values[searchFieldName] ?? ''}
        onChange={onChange}
        placeholder={searchPlaceholder}
        suggestions={searchSuggestions}
      />
      {showDateFilter ? (
        <FilterField
          label="Created Date"
          name="date"
          type="date"
          value={values.date}
          onChange={onChange}
        />
      ) : (
        <span className="hidden md:block" aria-hidden="true" />
      )}
      <FilterField
        label="Status"
        name="status"
        value={values.status}
        onChange={onChange}
        options={[
          { value: 'All', label: 'All Status' },
          ...statusOptions.map((status) => ({ value: status, label: status })),
        ]}
      />
    </FilterPanel>
  );
}

export default EntityFilters;
